<template>
  <v-dialog v-model="dialog" persistent width="1600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card>
          <v-card-text class="grey lighten-2 text--info"> </v-card-text>
          <v-card v-if="funcionario !== null">
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs3>
                    <strong>Nombre completo:  </strong>
                    {{ funcionario.nombre }}
                  </v-flex>
                  <v-flex xs3>
                    <strong>Número de documento: </strong>
                    {{ funcionario.nro_doc }}
                  </v-flex>
                  <v-flex xs3>
                    <strong>Fecha de incorporación: </strong>
                    {{ funcionario.fecha_ingreso }}
                  </v-flex>
                  <v-flex xs3>
                    <strong>Ítem: </strong>
                    {{ funcionario.item }}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
          <v-card-text class="grey lighten-2 text--info">
            <v-layout wrap>
              <v-flex class="px-3">
                <strong> Movimientos registrados </strong>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text>
            <v-layout>
              <v-flex>
                <v-data-table
                  :headers="headers"
                  :items="vMovimientosMovilidads"
                  class="elevation-1"
                  hide-actions
                  item-key="index"
                >
                  <template v-slot:items="items">
                    <td class="text-xs-center">{{ items.item.nro_item }}</td>
                    <td class="text-xs-center">{{ items.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ items.item.fecha_hasta }}</td>
                    <td class="text-xs-center">
                      {{ items.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">
                      {{ items.item.tipo_movimiento }}
                    </td>
                    <td class="text-xs-center">{{ items.item.unidad }}</td>
                    <td class="text-xs-center">{{ items.item.cargo }}</td>
                    <td class="text-xs-center">{{ items.item.puesto }}</td>
                    <td class="text-xs-center">
                      {{ items.item.nro_memorandum }}
                    </td>
                    <td class="text-xs-center">
                      <v-layout wrap row v-if="items.item.editar">
                        <v-flex xs3>
                          <v-btn
                            flat
                            color="red"
                            icon
                            @click.prevent="rechazar(funcionario.id_persona)"
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs3>
                          <v-btn
                            flat
                            color="success"
                            icon
                            @click.prevent="aprobar(funcionario.id_persona)"
                          >
                            <v-icon>check</v-icon>
                          </v-btn>
                        </v-flex>
                        
                      </v-layout>
                      <!-- <v-flex xs3 v-if="items.item.estado='Alta'">
                          <v-btn
                            flat
                            color="red"
                            icon
                            @click.prevent="anular(items.item)"
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-flex> -->
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card-actions>
          <small class="error--text text-required"></small>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ "cerrar" }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      url: "vMovimientosMovilidads",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        { text: "ITEM", sortable: false, align: "center" },
        { text: "Fecha desde", sortable: false, align: "center" },
        { text: "Fecha de conclusión", sortable: false, align: "center" },
        { text: "Fecha de registro", sortable: false, align: "center" },
        { text: "Tipo de movimiento", sortable: false, align: "center" },
        { text: "Unidad", sortable: false, align: "center" },
        { text: "Cargo", sortable: false, align: "center" },
        { text: "Puesto", sortable: false, align: "center" },
        { text: "Nro. Memorándum", sortable: false, align: "center" },
        { text: "Acciones", sortable: false, align: "center" },
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        id_persona
        nro_doc
        fecha_desde
        fecha_hasta
        fecha_registro
        cargo
        puesto
        unidad
        nro_item
        tipo_movimiento
        nro_memorandum
        id_tipo_justificacion
        id_puesto
        id_unidad
        id_cargo
      `,
      initData: [],
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [],
      form: {},
      funcionario: null,
      vMovimientosMovilidads: [],
      dialog: false,
      form: {},
      valid: false,
      loading: false,
    };
  },
  mounted() {
    this.$bus.$on("openDialogAprobarMovilidad", (item) => {
      //console.log(item.id_persona)
      this.obtenerDatos(item.id_persona);
      // this.aprobar(item.id_persona)
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    async obtenerDatos(id_persona) {
      let res = await this.$service.graphql({
        query: `
          query get($id: ID!){
            vListaPersonal(id: $id){
              nombre
              id_movilidad
              nro_doc
              fecha_ingreso
              item
              id_persona
              id_estado
              id_item
            }
          }
        `,
        variables: {
          id: id_persona,
        },
      });
      // if (res.vListaPersonal.id_estado == 2) {
      //   this.$router.push('/401')
      // }
      this.funcionario = res.vListaPersonal;
      // console.log('gfghfghfdghfdgh')
      // console.log(this.funcionario)
      res = await this.$service.graphql({
        query: `
          query{
            vMovimientosMovilidads(id_persona: ${res.vListaPersonal.id_persona}){
              rows{
                id
                id_persona
                nro_doc
                fecha_desde
                fecha_hasta
                fecha_registro
                cargo
                puesto
                unidad
                nro_item
                tipo_movimiento
                nro_memorandum
                id_tipo_justificacion
                id_puesto
                id_unidad
                id_cargo
              }
            }
          }
        `,
      });
      this.vMovimientosMovilidads = res.vMovimientosMovilidads.rows;
      this.vMovimientosMovilidads[0].editar = true;
    },

    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async aprobar() {
      //console.log(this.funcionario.id_persona)
      let user = this.$storage.get("user");
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select persona.fn_aprueba_rechaza_alta_persona(${user.id},${this.funcionario.id_persona},1)"){
                  respuesta
                }
              }
            `,
        });
        //console.log(respuesta)
        this.$message.success();
        this.close();
      } catch (error) {
        console.log(error);
      }
    },
    async rechazar() {
      //console.log(this.funcionario.id_persona)
      let user = this.$storage.get("user");
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select persona.fn_aprueba_rechaza_alta_persona(${user.id},${this.funcionario.id_persona},0)"){
                  respuesta
                }
              }
            `,
        });
        //console.log(respuesta)
        this.$message.success();
        this.close();
      } catch (error) {
        console.log(error);
      }
    },
    
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/AprobarMovilidad.vue